const Screen = ({ value, refCalc }) => {
  return (
    <p ref={refCalc} className="screen" mode="single" max={40}>
      {value}
    </p>
  );
};

export default Screen;
